import axios from "axios";
import { trim } from "lodash";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../Components/Global/Loader";
import DashboardLayouts from "../../../Components/Layout/DashboardLayouts";


import BackToDashboardBtn from "../../../Components/Global/BackToDashboardBtn";
import ButtonOutline from "../../../Components/Global/ButtonOutline";
import GallaryBox from "../../../Components/Global/GallaryBox";
import SubmitButton from "../../../Components/Global/SubmitButton";
import { InputTypeSelect, InputTypeText, InputTypeTextarea } from "../../../hooks/formsHandler/FormInputs";
import useGlobalFromData from "../../../hooks/formsHandler/useGlobalFromData";
import useAuthentication from "../../../hooks/useAuthentication";
import useAxiosFetch from "../../../hooks/useAxiosFetch";
import useMultipleImgUpload from "../../../hooks/useMultipleImgUpload";
import useStateProvince from "../../../hooks/useStateProvince";
import useToastify from "../../../hooks/useToastify";

function AddBuilding({ allowedRoles }) {
  const { allowLoading } = useAuthentication(allowedRoles);
  const{  axiosFetch} = useAxiosFetch()
    // show toast hook 
  const { notify } = useToastify();

  const [countryList, stateList, getProvinceFunc] = useStateProvince()
  const {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  } = useMultipleImgUpload();
  const _ = require("lodash");
  const route = useNavigate();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()



  const { stateData:formState, dispatch } =useGlobalFromData();



  let {id:building_id} = useParams();
 

  useEffect(() => {
    if (building_id) {
      getBuildingValue();

    }
  }, [building_id]);

  useEffect(() => {
    if (formState?.country) {

      getProvinceFunc(formState?.country)
    }
  }, [formState?.country])



  const getBuildingValue = () => {
    setLoading(false);
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `/building/show/${building_id}`,

    })
      .then((response) => {
        setLoading(false);
        if (response.data.buildingDetails?.[0]) {
          dispatch({ type: "load_data_api", payload: response.data.buildingDetails?.[0] })
         
        }
        if (response?.data?.buildingDetails?.[0]?.image) {


          const imgUrlMake = JSON.parse(
            response?.data?.buildingDetails?.[0]?.image
          )?.map((im) => ({ url: im }));
          setSelectedImages(imgUrlMake);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const validation = (value) => {
    const errors = {};
    const allTextType = /^[A-Za-z0-9 ]+$/;
    const validateField = ["province", "country", "postal_code", "city", "building_name", "street_address"];
    const validateTypeField = ["building_name"];


    validateField.map(input => {

      if (!formState[input] || !trim(formState[input])) {

        return errors[input] = `Please enter your ${input.includes("_") ? input.split("_").join(" ") : input}.`
      } else {
        validateTypeField.map(uuu => {
          if (!allTextType.test(formState[uuu])) {

            return errors[uuu] = `Please enter a valid your ${uuu.includes("_") ? uuu.split("_").join(" ") : uuu}.`
          }

        })
      }


    })



    if (building_id) {
      if (!formState?.building_code) {
        errors.building_name = "Please enter your buliding code.";
      }
    }



    if (selectedImages.length > 10) {
      errors.imgs = "Please choose images less than 10";
    }



    dispatch({ type: "building_error", payload: errors })

    return errors;
  };



  const SubmitBuilding = async (e) => {
    e.preventDefault();
    const abc = validation();
dispatch({type:"ser_errors",payload:abc})
    if (Object.keys(abc).length === 0) {
      setLoading(true);

      const filterImages = selectedImages.filter(
        (file) => !file.url.includes("blob:")
      );

      const removeUrlTag = filterImages.map((img) => img.url);
      if (selectedImages.length == 0) {
        buildingFuncWithImg([]);
      } else if (selectedImages.filter((img) => img.file !== undefined).length == 0) {
        buildingFuncWithImg(removeUrlTag);
      }


      try {
        const images = await uploadToserver("building_image", setLoading);

        await buildingFuncWithImg([...removeUrlTag, ...images?.data?.links]);
      } catch (error) {
        setLoading(false);
      }



    }
  };

  const buildingFuncWithImg = (imagesss) => {

    setLoading(true);
    let data = {
      ...formState,
      status:true,
      image: JSON.stringify(imagesss)
    };


    const url = building_id ? `/building/update/${building_id}` : "/building/create";


    const fetchData = {
      axiosInstance: axios,
      method: "post",
      url: url,
      navigatesUrl: "/buildinglist",
      requestConfig: data,
    }
    axiosFetch(fetchData)

  };










  const buildingInputs = [
    {
    
      name: "building_name",
      type: "text",
      placeholder: "Building Name",
      errorMessage:
        "Username should be 3-16 characters and shouldn't include any special character!",
      label: "Building Name",
      pattern: "^[A-Za-z0-9]{3,16}$",
      required: true,
      isShow: true,
      colSize:12
    },
    {
    
      name: "building_code",
      type: "text",
      placeholder: "Building Code",
      errorMessage: "It should be a valid email address!",
      label: "Building Code",
      required: true,
      isShow: building_id ? true : false,
      colSize:12

    },
    {
    
      name: "street_address",
      type: "text",
      placeholder: "Street Address",
      label: "Street Address",
      required: true,
      isShow: true,
      colSize:12

    },
    {
    
      name: "country",
      type: "selectbox",
      placeholder: "Country",
      label: "Country",
      required: true,
      isShow: true,
      colSize:6

    },
    {
    
      name: "province",
      type: "selectbox",
      placeholder: "Province",
      label: "Province",
      required: true,
      isShow: true,
      colSize:6

    },
   
    {
    
      name: "city",
      type: "text",
      placeholder: "City",
      errorMessage: "It should be a valid email address!",
      label: "City",
      required: true,
      isShow: true,
      colSize:6

    },
    {
    
      name: "postal_code",
      type: "text",
      placeholder: "Postal Code",
      errorMessage: "It should be a valid email address!",
      label: "Postal Code",
      required: true,
      isShow: true,
      colSize:6

    },
    {
     
      name: "Description",
      type: "textarea",
      placeholder: "Description",
      errorMessage: "It should be a valid email address!",
      label: "Description",
      required: true,
      isShow: true,
      colSize:12

    },

  ];






  return (
    <>
      <DashboardLayouts>
        {(loading || allowLoading) && <Loader />}
        <div className="breadcrumb row justify-content-between align-items-center">
         <BackToDashboardBtn/>

          <div className="col-auto btn-responsive">
           

            <ButtonOutline navigateUrl="/buildinglist" text="Back To Building List" />
            {building_id && (

            <ButtonOutline navigateUrl={`/add-units/${building_id}`} text="Add Unit" />

            
            )}
          </div>
        </div>
        <div className="w-100 list-data">
          <h1 className="heading-text mb-4">
            {!building_id ? "Add Building" : "Edit Building"}
          </h1>
        </div>
        <form className="dash-form add-form add-building-area">
          <div className="row">
            <div className="col-xl-7 col-xxl-8">
              <div className="row gy-1 gy-md-4 gx-xl-5">
                <>
                  {
                    buildingInputs?.filter(buildingInput => (buildingInput.isShow)).map(({required,type,label,placeholder,colSize,name},index) => (
                      <>
                     
                     {
                      type=="selectbox" ?
                      
                      <InputTypeSelect
                      required={required}

                      optionsList={name =="country" ? countryList : stateList }
                      optionName={name =="country" ? "country_name" : "province_name"}
                        
                        label={label}
                      type={type}
                      name={name}
                      placeholder={placeholder}
                      errorMessage={formState?.errorMessage?.[name]}
                      dispatch={dispatch}
                      stateData={formState}
                      colSize={colSize}
                        />
                    
                    :
                    
                    
                    type=="textarea" ?   


                    <InputTypeTextarea
                    label={label}
                    type={type}
                    name={name}
                    placeholder={placeholder}
                    required={required}
                   
                    dispatch={dispatch}
                    stateData={formState}
                    errorMessage={formState?.errorMessage?.[name]}
                    colSize={colSize} />
                     :
                 <InputTypeText
                 required={required}
                 
                 label={label}
                 type={type}
                 name={name}
                 placeholder={placeholder}
                 errorMessage={formState?.errorMessage?.[name]}

                 dispatch={dispatch}
                 stateData={formState}
                 colSize={colSize}
                 
                 />
                     }
                     
                        
                      </>
                    ))
                  }
                </>





                
              </div>
            </div>

            <GallaryBox selectedImages={selectedImages} defaultImg={defaultImg} handleDefaultImage={handleDefaultImage} onSelectFile={onSelectFile} deleteHandler={deleteHandler} />
            <div className="col-xl-12 col-md-6 mt-4 col-md-6">
            
              <SubmitButton submitHandler={SubmitBuilding} text={!building_id ? "Add now" : "Update now"}/>
            </div>
          </div>
        </form>
      </DashboardLayouts>
    </>
  );
}
export default AddBuilding;
